import { useModalContext } from '#pplx/frontend/aether/modals/context/useModalContext.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
import { useCallback } from 'react';
const ConnectorModalBySourceId = Dynamic(async () => {
    const { ConnectorModalBySourceId } = await import('#pplx/frontend/apps/ask/connectors/modal-navigation/ConnectorModalBySourceId.js');
    return { default: ConnectorModalBySourceId };
});
export function useOpenConnectorModalBySourceId({ reason, referrer, openModal: openModalOverride, }) {
    const { openModal: localOpenModal } = useModalContext();
    const openModal = openModalOverride ?? localOpenModal;
    return useCallback((params) => {
        openModal(ConnectorModalBySourceId, { ...params, reason, referrer }, { replace: false });
    }, [openModal, reason, referrer]);
}
//# sourceMappingURL=useOpenConnectorModalBySourceId.js.map